import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "d-flex justify-content-end" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["onClick", "data-kt-indicator", "disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Save ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_AddressForm = _resolveComponent("AddressForm")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    "validation-schema": _ctx.formSchema,
    "initial-values": _ctx.formData,
    ref: "createAgencyForm"
  }, {
    default: _withCtx(({ handleSubmit, validate, values }) => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(($event: any) => (handleSubmit(_ctx.submitForm)), ["prevent"]),
        class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
        id: "create-agency-form",
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('business_name', _ctx.prefix),
              containerClass: "col-lg-6 col-md-6 col-12",
              label: "Name",
              placeholder: "Name"
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('subtitle', _ctx.prefix),
              containerClass: "col-lg-6 col-md-6 col-12",
              label: "Subtitle",
              placeholder: "Subtitle"
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('discount', _ctx.prefix),
              containerClass: "col-lg-4 col-md-4 col-12",
              label: "Discount",
              placeholder: "Discount"
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: true,
              name: _ctx.addPrefix('business_website', _ctx.prefix),
              containerClass: "col-lg-4 col-md-4 col-12",
              label: "Website",
              placeholder: "example.com"
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: true,
              name: _ctx.addPrefix('business_phone_number', _ctx.prefix),
              containerClass: "col-lg-4 col-md-4 col-12",
              label: "Phone Number",
              placeholder: "Phone Number",
              mask: _ctx.phoneMasking
            }, null, 8, ["name", "mask"]),
            _createVNode(_component_AddressForm, {
              values: values,
              country: values.country,
              state: values.state,
              colClass: "d-inline-flex gap-3",
              onCountryChange: _ctx.handleCountryChange,
              onCountryBlur: _ctx.handleCountryBlur,
              onStateChange: _ctx.handleStateChange,
              onStateBlur: _ctx.handleStateBlur
            }, null, 8, ["values", "country", "state", "onCountryChange", "onCountryBlur", "onStateChange", "onStateBlur"]),
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('description', _ctx.prefix),
              containerClass: "col-lg-12 col-md-12 col-12",
              label: "Description",
              placeholder: "Description",
              type: "textarea"
            }, null, 8, ["name"])
          ]),
          _createVNode(_component_el_divider),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args))),
              class: "btn btn-white me-3",
              disabled: _ctx.loading
            }, " Cancel ", 8, _hoisted_5),
            _createElementVNode("button", {
              onClick: validate,
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              class: "btn btn-lg btn-primary fw-bolder me-4",
              disabled: _ctx.loading
            }, _hoisted_9, 8, _hoisted_6)
          ])
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["validation-schema", "initial-values"]))
}